import { FC } from 'react';
import css from './index.module.scss';
// import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export const ZFComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`${css.ZFComp} GtmModuleData-section`} data-section-id={css.ZFComp} data-section-title={t('sec15_title')}>
            <div className="subtitle">{t('sec15_subtitle')}</div>
            <div className="title">{t('sec15_short_title')}</div>
            <div className="img-box">
                {/* <EFVideo
                    className="video fullImgs"
                    sources={['/video/delta2max/teaser/pc/eu/14.webm', '/video/delta2max/teaser/pc/eu/14.mp4']}
                    width="100%"
                    height="100%"
                    aria-label={t('sec15_short_title')}
                /> */}
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zf.webp')}
                    src={require('@publicLocal/delta2max/teaser/pc/eu/zf.jpg')}
                    alt={t('sec15_short_title')}
                    aria-label={t('sec15_short_title')}
                />
            </div>
            <div className="desc">{t('sec15_desc')}</div>
            <div className="item-list">
                <div className="item-box">
                    <div className="item-title">{t('sec15_2048')}</div>
                    {t('sec15_d2x')}
                </div>
                <div className="item-box">
                    <div className="item-title">{t('sec15_4096')}</div>
                    {t('sec15_d2x_battery1')}
                </div>
                <div className="item-box">
                    <div className="item-title">{t('sec15_6144')}</div>
                    {t('sec15_d2x_battery2')}
                </div>
            </div>
        </div>
    );
};
